
import { defineComponent, onMounted, ref } from "vue"
import { useRoute } from 'vue-router';

export default defineComponent({
  name: "web",

  setup() {
    const route = useRoute()
    const url = ref('')
    const school_type = ref()

    onMounted(() => {
      school_type.value = route.query.school_type || '1'
      console.log('onMounted')
      if (school_type.value === '2') {
        // window.location.href = 'https://www.12kcool.com/face-qiye.html'
        url.value = 'https://www.12kcool.com/face-qiye.html'
      } else {
        // window.location.href = 'https://www.12kcool.com/face-school.html'
        url.value = 'https://www.12kcool.com/face-school.html'
      }
    })
    return {
      url,
      school_type
    }
  },
})
